module.exports = __webpack_public_path__ + "media/images/riders/SAMUEL_BLEKINSOP-62663c878cd52ade41af61789e1bbf4d.png";